import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'
import { OrganisationRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { TypeOfElement } from 'types/generic'
import { Dropdown } from '../../../components/common/dropdown/Dropdown'
import IconSettings from '../../../components/common/icon/IconSettings'
import IconPlus from '../../../components/common/icon/IconPlusInCircle'
import IconClose from '../../../components/common/icon/IconClose'
import IconKey from '../../../components/common/icon/IconKey'
import {
  ManageUsersPageContextType,
  useManageUsersPageContext
} from '../ManageUsersPageContext'
import { ArchiveUserModal } from './ArchiveUserModal'
import { ManageUsersPageQuery } from '../ManageUsersPage.codegen'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

type User = TypeOfElement<
  NonNullable<
    NonNullable<ManageUsersPageQuery['admin']>['organisation']
  >['users']
>

export interface IPublicProps {
  user: User
  onAddToGroup?: () => void
}

export const UserMenu = ({
  user,
  onAddToGroup
}: IPublicProps &
  Pick<ManageUsersPageContextType, 'onRemoveUser' | 'onRoleChange'>) => {
  const { session } = usePublicApiSession()
  const [showArchiveUserModal, setShowArchiveUserModal] = useState(false)
  const { onRoleChange, fetchUsers } = useManageUsersPageContext()

  const handleRoleChange = () => {
    const { id: target, organisation_role } = user
    const role =
      organisation_role === OrganisationRoleEnum.ADMIN
        ? OrganisationRoleEnum.STUDENT
        : OrganisationRoleEnum.ADMIN
    onRoleChange && onRoleChange({ target, role })
  }

  const handleRemoveUser = () => {
    setShowArchiveUserModal(true)
  }

  const renderOtherUserButtons = () => {
    const { id, organisation_role } = user
    if (id === session?.user.id) {
      return null
    }

    return (
      <>
        <a className="DropdownLink" key={1} onClick={() => handleRoleChange()}>
          <IconKey />
          {organisation_role === 'ADMIN'
            ? t`Change role to General user`
            : t`Change role to Full administrator`}
        </a>
        <a className="DropdownLink" key={2} onClick={() => handleRemoveUser()}>
          <IconClose />
          <Trans>Archive user</Trans>
        </a>
      </>
    )
  }

  const renderMenu = () => {
    return (
      <div>
        <a
          className="DropdownLink"
          onClick={() => (onAddToGroup ? onAddToGroup() : {})}
          key={0}
        >
          <IconPlus />
          <Trans>Add to group</Trans>
        </a>
        {renderOtherUserButtons()}
      </div>
    )
  }

  return (
    <>
      <Dropdown key={0} content={renderMenu()}>
        <IconSettings />
      </Dropdown>
      <ArchiveUserModal
        actionName={t`archive`}
        userId={user.id}
        show={showArchiveUserModal}
        onCanceled={() => setShowArchiveUserModal(false)}
        onDeleted={() => {
          setShowArchiveUserModal(false)
          fetchUsers && fetchUsers()
        }}
      />
    </>
  )
}

export default UserMenu
